<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_ADMIN'"><a routerLink="/admin/adminDashboard/">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">Configuration</li>
    </ol>
  </nav>

  <div class="row mt-3">
    <div class="col">

      <div class="inner-box pt-4 pb-4">

        <div class="row">

          <div class="col-md-3">
            <div class="form-group mb-md-0">
              <label class="control-label">Carrier Name</label>
              <select class="form-control" id="carrierError" [(ngModel)]="carrier"
                      (change)="trackingNumberFunction(carrier)" [ngModelOptions]="{standalone: true}"
                      [ngClass]="{'is-invalid':carrierError}" required>
                <option value="GT">Gati</option>
                <option value="KE">Kerry</option>
                <option value="EE">eComExpress</option>
              </select>
            </div>
          </div>

        </div>

      </div>

      <div class="inner-box pt-4 pb-4 mt-2">

        <div class="row">

          <div class="col-md-3" *ngIf="carrier === 'GT'">
            <div class="form-group mb-md-0">
              <label class="control-label">Upload Docket Numbers</label>
              <input type="text" id="UploadDocketNumbers" [(ngModel)]="uploadDocketNumbers" class="form-control"
                     [ngModelOptions]="{standalone: true}" required>
            </div>
          </div>

          <div class="col-md-3" *ngIf="carrier === 'GT'">
            <div class="form-group mb-md-0">
              <label class="control-label">Upload Package Numbers</label>
              <input type="text" id="UploadPackageNumbers" [(ngModel)]="uploadPackageNumbers" class="form-control"
                     [ngModelOptions]="{standalone: true}" required>
            </div>
          </div>

          <div class="col-md-3" *ngIf="carrier === 'KE'">
            <div class="form-group mb-md-0">
              <label class="control-label"> Upload csv File </label><br>
              <label class="import_products add_file mt-2">
                <input class="shift-import-input" type="file" (change)="loadOrder($event)" [(ngModel)]="fileUpload"
                       [ngModelOptions]="{standalone: true}" name="file" accept="application/csv+json"/>
                <span *ngIf="!fileUpload || fileUpload == ''"> <img src="/./assets/images/Group_1645.svg"
                                                                    style="margin-right: 10px;" alt="fileUpload">Add file</span>
                <span *ngIf="fileUpload"><img src="/./assets/images/xx.png" style="margin-right: 10px;width:20px;"
                                              (click)="removeFile()"
                                              alt="fileUpload">{{getFileName(fileUpload)}}</span>
              </label>
              <div id="fileUploadError" class="invalid-feedback d-block mb-2" [hidden]="!fileUploadError">
                {{fileUploadError}}
              </div>
              <br>
              <br>
              <button type="button" *ngIf="fileUpload" style="margin-bottom:50px;"
                      class="btn btn-orange file shift-import ml-2"
                      (click)="submitConfiguration()">Import
              </button>
            </div>
          </div>

          <div class="col-md-3" *ngIf="carrier === 'EE'">
            <div class="form-group mb-md-0">
              <label class="control-label">Payment Type</label>
              <select class="form-control" id="paymentType" [(ngModel)]="paymentType" (blur)="paymentTypeBlur()"
                      [ngModelOptions]="{standalone: true}"
                      [ngClass]="{'is-invalid':paymentTypeError}" required>
                <option value="cod">Cash On Delivery</option>
                <option value="ppd">Prepaid</option>
              </select>
            </div>
          </div>

          <div class="col-md-3" *ngIf="carrier === 'EE'">
            <div class="form-group mb-md-0">
              <label class="control-label">Subtype</label>
              <select class="form-control" id="subType" [(ngModel)]="subType" (blur)="subTypeBlur()"
                      [ngModelOptions]="{standalone: true}"
                      [ngClass]="{'is-invalid':subTypeError}" required>
                <option value="PRO">PRO</option>
                <option value="EGS">EGS</option>
              </select>
            </div>
          </div>

        </div>

        <div class="row mt-4">
          <div class="col">
            <label class="text-black">Available Tracking Numbers {{trackingNumber?.count || 0}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="form-btn-section">
    <div class="col-12 text-right">
      <button type="submit" *ngIf="carrier === 'EE'" id="submitDonation" class="btn btn-orange-prime ml-2"
              (click)="submitPaymentType()">Submit
      </button>
    </div>
  </div>

</section>
